var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppLightSchemePreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 208,
  height: 138,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#app-light-scheme-preview_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h188.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C208 4.56 208 6.24 208 9.6v118.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622c-1.284.654-2.964.654-6.324.654H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 133.44 0 131.76 0 128.4z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#app-light-scheme-preview_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 222,
  height: 173,
  x: 24,
  y: 24,
  fill: "#F9F9F9",
  rx: 8
}), /*#__PURE__*/React.createElement("mask", {
  id: "app-light-scheme-preview_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 24h76v173H24z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 24h76v173H24z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M99 24v173h2V24z",
  mask: "url(#app-light-scheme-preview_svg__c)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 32,
  y: 34,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 80,
  y: 34,
  fill: "#F0F0F0",
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32,
  y: 72,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32,
  y: 84,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32,
  y: 96,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32,
  y: 108,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 32,
  y: 120,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 4,
  x: 48,
  y: 38,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 4,
  x: 42,
  y: 73,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 4,
  x: 42,
  y: 85,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 4,
  x: 42,
  y: 97,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 4,
  x: 42,
  y: 109,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 4,
  x: 42,
  y: 121,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 10,
  x: 32,
  y: 54,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("mask", {
  id: "app-light-scheme-preview_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100 24h132v30H100z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M100 24h132v30H100z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M232 53H100v2h132z",
  mask: "url(#app-light-scheme-preview_svg__d)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 108,
  y: 34,
  fill: "#F0F0F0",
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 4,
  x: 122,
  y: 37,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 4,
  x: 108,
  y: 62,
  fill: "#000",
  fillOpacity: 0.06,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 36,
  x: 108,
  y: 72,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 108.5,
  y: 72.5,
  stroke: "#000",
  strokeOpacity: 0.06,
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 36,
  x: 108,
  y: 114,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 108.5,
  y: 114.5,
  stroke: "#000",
  strokeOpacity: 0.06,
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 4,
  x: 180,
  y: 62,
  fill: "#000",
  fillOpacity: 0.06,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 36,
  x: 180,
  y: 72,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 180.5,
  y: 72.5,
  stroke: "#000",
  strokeOpacity: 0.06,
  rx: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 36,
  x: 180,
  y: 114,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 35,
  x: 180.5,
  y: 114.5,
  stroke: "#000",
  strokeOpacity: 0.06,
  rx: 3.5
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "app-light-scheme-preview_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h188.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C208 4.56 208 6.24 208 9.6v118.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622c-1.284.654-2.964.654-6.324.654H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 133.44 0 131.76 0 128.4z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "app-light-scheme-preview_svg__b",
  width: 286,
  height: 237,
  x: -12,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_507_3260"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_507_3260",
  result: "shape"
})))));
export { SvgAppLightSchemePreview as ReactComponent };
export default "data:image/svg+xml;base64,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";